import React, { Component } from 'react';
import { connect } from 'react-redux';
import './css/Verification.css';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { addBankCard } from '../action/myCardsAction.js';
import { requestAuthentication } from '../action/myCardsAction.js';
import { setStorage,getTempInfo } from '../common';
import Util from '../util';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from './NavigatorMain';

let count=120;
class Verification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnFlag:false,
      text:'',
      yzm:0,
      cardVal: "获取验证码",
      checkFlag: false,
      dynamicCode: '',
      authRequestNo: '',
    };
  }
  componentWillMount(){
    let {dispatch}=this.props;
    let params=this.props.location.query
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  btnCallBack1(x){
    hashHistory.go(1-x)
  }
  next(content,i){
    Toast.hide()
    let {text} =this.state;
    if (i==1) {
        hashHistory.push({
          pathname:'/Success',
          state: {
            title:'添加银行卡',
            content:'您的银行卡已绑定成功',
            dataSouse:[],
            souseVal:['查看银行卡'],
            fundCode:this.props.location.state.fundCode,
          },
        });
    } else{
        Toast.info( content, Util.ToastTime );
    }
  }

  getRandomInt = (min, max) => {
    return Math.floor(min + Math.random() * max);
  }

  async toAddBankCard(){
    let randomInt = this.getRandomInt(1, 100000);
    this.setState({loadingFlag: true});
    let params = {
      token: await getTempInfo('shortToken'),
      mobileNo: this.props.location.state.mobileNo,
      bankCode: this.props.location.state.bankCode,
      bankAccountShowNo: this.props.location.state.bankAccountShowNo,
      captcha: this.state.text,
      authRequestSNo: this.state.authRequestNo,
      bankProtocolVersion: this.props.location.state.bankProtocolVersion,
      upProtocolVersion: this.props.location.state.upProtocolVersion,
      clientType: Util.return_Clinet_Type(),
      clientDeviceNo:"hxcfH5"+randomInt,
      paymentChannelId: this.props.location.state.trustChannelId
    }
    Toast.loading('', 0, () => {});
    console.log(params)
    this.props.dispatch(addBankCard(params,(content)=>this.next(content,1),(msg)=>this.next(msg,2)));
  }
  onChangeText(e){
     this.setState({
      text:e.target.value
    })
    // let flag=Util.regular1.test(e.target.value)
    // if (flag&&e.target.value.length!==6) {
    //   this.setState({
    //       btnFlag:false
    //   })
    // }else{
    //   this.setState({
    //       btnFlag:true
    //   })
    // }
  }
  componentWillUnmount(){
    clearInterval(window.timer);
  }
  requestAuthenticationSuccess(content){
    this.setState({loadingFlag: false});
    this.setState({authRequestNo: content.requestNo});
  }

  requestAuthenticationError(msg){
    // this.setState({loadingFlag: false});
    Toast.info( msg, Util.ToastTime );

  }
  async getYZM(){
    let randomInt = this.getRandomInt(1, 100000);
    let params = {
      token: await getTempInfo('shortToken'),
      paymentChannelId: this.props.location.state.trustChannelId,
      bankAccountShowNo: this.props.location.state.bankAccountShowNo,
      mobileNo: this.props.location.state.mobileNo,
      businessType: 'AddCard',
      clientType: Util.return_Clinet_Type(),
      clientDeviceNo: "hxcfH5"+randomInt
    }
    this.props.dispatch(requestAuthentication(params, (content)=>this.requestAuthenticationSuccess(content), (msg)=>this.requestAuthenticationError(msg)))
    
    this.setState({
      yzm:120
    })
    count=120;
    
    window.timer=setInterval(function () {
      if (count>0) {
        count-=1;
        this.setState({
          yzm:count
        })
      }else{
        clearInterval(window.timer);
        count=120;
      }
    }.bind(this),1000)
  }

  render(){
    console.log(this.props.location.state);
    let flag=Util.regular1.test(this.state.text)
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="BindingMobile-header">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>添加银行卡</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content'>
           <div className='share'>
              <div className='shareTitle'>
                请输入您收到的短信验证码
              </div>
            </div>
            <div className='Verification-input-box'>
              <p >验证码</p>
              <input autocomplete="off"  onChange={(e)=>this.onChangeText(e)} type="text" value={this.state.text} placeholder={''} />
              {this.state.yzm!==0?<div className='Verification-input-yzm1 Verification-input-yzm2'>
                <span>{this.state.yzm}秒后重发</span>
            </div>:<div onClick={()=>this.getYZM()} className='Verification-input-yzm1'>
                <span >获取验证码</span>
            </div>}
            </div>
            {flag&&this.state.authRequestNo?
            <div onClick={()=>this.toAddBankCard()} className='btn'>
              下一步
            </div>:
            <div  className='btn btn-gray'>
              下一步
            </div>
            }
          </div>
          
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    
  }
}
export default connect(mapStateToProps)(Verification);



// WEBPACK FOOTER //
// ./src/components/Verification.js